"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckMailRequestPayloadToJSON = exports.CheckMailRequestPayloadFromJSONTyped = exports.CheckMailRequestPayloadFromJSON = void 0;
function CheckMailRequestPayloadFromJSON(json) {
    return CheckMailRequestPayloadFromJSONTyped(json, false);
}
exports.CheckMailRequestPayloadFromJSON = CheckMailRequestPayloadFromJSON;
function CheckMailRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
exports.CheckMailRequestPayloadFromJSONTyped = CheckMailRequestPayloadFromJSONTyped;
function CheckMailRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
    };
}
exports.CheckMailRequestPayloadToJSON = CheckMailRequestPayloadToJSON;
//# sourceMappingURL=CheckMailRequestPayload.js.map